import React, { useEffect, useState } from 'react';
import CustomText from '../../../Common/customComponents/CustomText.tsx';
import { commonMsg, companyUtil, dateUtil, systemCdUtil } from '../../../../utils/globalUtil.tsx';
import CustomButton from '../../../Common/customComponents/CustomButton.tsx';

import SampleMapImage from '/assets/icon/global/sample-map-image.svg';
import CustomSelectSingle from '../../../Common/customComponents/CustomSelectSingle.tsx';
import CustomDatetime from '../../../Common/customComponents/CustomDatetime.tsx';
import CustomNumber from '../../../Common/customComponents/CustomNumber.tsx';
import FormApproval from './approval/FormApproval.tsx';
import CustomTextarea from '../../../Common/customComponents/CustomTextarea.tsx';
import PermitIssueForm from './PermitIssueForm.tsx';
import CustomDate from '../../../Common/customComponents/CustomDate.tsx';
import WorkLocationModal from '../modal/WorkLocationModal.tsx';
import PermitIssueMap from './PermitIssueMap.tsx';
import { safObjectHelper } from '../../../../utils/SafObjectHelper.ts';
import { ptwApi } from '../../../../api/ptw.api.ts';
import UserSearchModal from 'containers/ptw/Setting/modal/UserSearchModal.tsx';
import FormTabXBlack from '/assets/icon/global/form-tab-x-black.svg';
import OperatorModal from '../modal/OperatorModal.tsx';
import { useAsync } from 'hooks/useAsync.ts';
import { codeApi } from '../../../../api/code.api.ts';
import CustomUploader from 'containers/Common/customComponents/CustomUploader.tsx';
import DashIcon from '/assets/icon/global/cancel.svg';
import ClockIcon from '/assets/icon/global/extension.svg';
import ActionClock from '/assets/icon/global/action-clock.svg';
import ExtensionHistoryModal from '../modal/ExtensionHistoryModal.tsx';

interface IProps {
  data: any;
  setData: any;
  handleChange: any;
  formCode: string;
  isReadOnly: boolean;
  userInfo: any;
  isFinish: boolean;
  mainPermitData: any;
}

const Form05LiftingDetail = (props: IProps) => {
  /*일반*/
  const [searchData, setSearchData] = useState<any>({});
  const { callAsync, showAlarm, closeAlarm } = useAsync();
  const [isWorkLocationModalOpen, setIsWorkLocationModalOpen] = useState<boolean>(false);
  const [isExtHistoryModalOpen, setIsExtHistoryModalOpen] = useState<boolean>(false);
  const [isUserSearchModalOpen, setIsUserSearchModalOpen] = useState<boolean>(false);
  const [selectedUserList, setSelectedUserList] = useState<any>([]);
  const [searchKeyword, setSearchKeyword] = useState<string>('');
  /*공통코드*/
  const [disciplineCdList, setDisciplineCdList] = useState<any>([]);
  const [workCdList, setWorkCdList] = useState<any>([]);
  const [taskCdList, setTaskCdList] = useState<any>([]);
  const [manpowerOptions, setManpowerOptions] = useState<any>([]);
  const [companyList, setCompanyList] = useState<any>([]);

  useEffect(() => {
    codeApi.getDiscpCodeList().then((list) => {
      setDisciplineCdList(list);
      setWorkCdList([]);
      setTaskCdList([]);
    });
    codeApi.getManpowerCodeList(props.formCode).then((list) => {
      setManpowerOptions(list);
    });
    companyUtil.getOptions().then((list) => {
      setCompanyList(list);
    });
  }, []);
  useEffect(() => {
    codeApi.getDiscpCodeList(props.data?.disciplineCd).then((list) => {
      setWorkCdList(list);
      setTaskCdList([]);
    });
  }, [props.data?.disciplineCd]);

  useEffect(() => {
    codeApi.getDiscpCodeList(props.data?.workCd).then((list) => {
      setTaskCdList(list);
    });
  }, [props.data?.workCd]);

  useEffect(() => {
    if (!props.data || Object.keys(props.data).length === 0) {
      props.setData((prev: any) => ({
        ...prev,
        workRisk: 'HIGH',
        companyId: props.userInfo?.companyId
      }));
    }
  }, [props.data]);

  const addManPower = () => {
    props.setData((prev: any) => {
      const prevList: any[] = prev?.manPower ?? [];

      const next = [...prevList, { manPower1: null, manPower2: 0 }].map((row, idx) => ({
        ...row,
        seq: idx + 1
      }));

      return { ...prev, manPower: next };
    });
  };

  const delManPower = (index: number) => {
    props.setData((prev: any) => {
      const prevList: any[] = prev?.manPower ?? [];

      const next = prevList
        .filter((_: any, i: number) => i !== index)
        .map((row: any, idx: number) => ({
          ...row,
          seq: idx + 1
        }));

      return { ...prev, manPower: next };
    });
  };

  const handleChangeManPower = (index: number, field: string, e: any) => {
    const value = e?.target ? e.target.value : e;

    props.setData((prev: any) => {
      const prevList: any[] = prev?.manPower ?? [];

      const next = prevList.map((row: any, i: number) => {
        if (i === index) {
          return { ...row, [field]: value, seq: i + 1 };
        }
        return { ...row, seq: i + 1 };
      });

      return { ...prev, manPower: next };
    });
  };

  const workLocationCallback = (location: any, locationText: any) => {
    props.handleChange({
      target: {
        name: 'location',
        value: location,
        type: 'json'
      }
    });
    props.handleChange({
      target: {
        name: 'locationText',
        value: locationText
      }
    });
    setIsWorkLocationModalOpen(false);
  };

  const onActionUserSearchCallback = (checkedList: any[]) => {
    if (!checkedList) return;

    props.handleChange({
      target: {
        name: 'operator',
        value: checkedList.map((v: any) => String(v.userNm))
      }
    });
    commonMsg.alert(showAlarm, closeAlarm, 'Success', 'It has been Added.', null);
  };

  const deleteOperatorItem = (item: string) => {
    const updated = (props.data?.operator ?? []).filter((i: string) => i !== item);

    if (props.handleChange) {
      props.handleChange({
        target: {
          name: 'operator',
          value: updated
        }
      });
    }
  };

  return (
    <>
      <WorkLocationModal
        setIsModalOpen={setIsWorkLocationModalOpen}
        isModalOpen={isWorkLocationModalOpen}
        onActionCallback={workLocationCallback}
        location={props.data?.location}
        locationText={props.data?.locationText}
      />
      <OperatorModal
        setIsModalOpen={setIsUserSearchModalOpen}
        isModalOpen={isUserSearchModalOpen}
        title={'Operator'}
        onActionCallback={onActionUserSearchCallback}
        selectedList={selectedUserList}
        searchKeyword={searchKeyword}
      />
      <div className={'cold-detail'}>
        {props.mainPermitData?.approvalStatus === 'CANCEL' && (
          <div className="cancel-area">
            <img src={DashIcon} alt="ban icon" className="cancel-icon" />
            <div className="cancel-content-area">
              <div className="cancel-title">
                <span className="cancel-title-text">Permit Cancelled</span>
              </div>
              <div className="cancel-content">
                <div className="cancel-content-detail">
                  <span className="cancel-content-name">{props.mainPermitData?.cancellerNm}</span>
                  <span>·</span>
                  <span className="cancel-content-comment">
                    {props.mainPermitData?.cancelComment}
                  </span>
                </div>
                <div className="cancel-date">
                  <img src={ActionClock} alt="ban icon" className="action-icon" />
                  <span>{dateUtil.formatDate(props.mainPermitData?.cancelDate)}</span>
                </div>
              </div>
            </div>
          </div>
        )}
        {props.mainPermitData?.extendDate && (
          <div className="extend-area">
            <ExtensionHistoryModal
              isModalOpen={isExtHistoryModalOpen}
              setIsModalOpen={setIsExtHistoryModalOpen}
              ptwDSeq={props.mainPermitData?.ptwDSeq}
            />
            <img src={ClockIcon} alt="ban icon" className="extend-icon" />
            <div className="extend-content-area">
              <div className="extend-title">
                <span className="extend-title-text">Extension Approved</span>
                <button
                  className="extend-history-btn"
                  onClick={() => setIsExtHistoryModalOpen(true)}
                >
                  EXTENSION HISTORY
                </button>
              </div>
              <div className="extend-content">
                <div className="extend-content-detail">
                  <span className="extend-content-name">{props.mainPermitData?.extenderNm}</span>
                  <span>·</span>
                  <span className="extend-content-comment">{props.mainPermitData?.comment}</span>
                </div>
                <div className="extend-date">
                  <img src={ActionClock} alt="ban icon" className="action-icon" />
                  <span>{dateUtil.formatDate(props.mainPermitData?.extendDate)}</span>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="contents-watermark-wrapper">
          <div
            className={
              'form-contents ' +
              (props.mainPermitData?.approvalStatus === 'CANCEL' ? 'form-cancel-watermark' : '')
            }
          >
            {/* renew로 생성시킨 데이터 */}
            {props.data?.refPtwDSeq && (
              <>
                <div className={'form-sub-title'}>Renewal Reference</div>
                <table className={'form-table'}>
                  <tbody>
                    <tr>
                      <th className={'form-required'} style={{ width: '300px' }}>
                        Renewed from Permit No
                      </th>
                      <td>
                        <CustomText
                          onChange={props.handleChange}
                          name={'refPtwNo'}
                          className={'form'}
                          readOnly={true}
                          value={props.data?.refPtwNo}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </>
            )}
            <table className={'form-table'}>
              <tbody>
                <tr>
                  <th style={{ width: '300px' }}>Permit No</th>
                  <td>
                    <CustomText
                      onChange={props.handleChange}
                      name={'ptwNo'}
                      className={'form'}
                      readOnly={true}
                      value={props.data?.ptwNo}
                    />
                  </td>
                </tr>
                <tr>
                  <th className={'form-required'}>Company Name</th>
                  <td>
                    <CustomSelectSingle
                      name={'companyId'}
                      className={'form'}
                      onChange={props.handleChange}
                      value={props.data?.companyId}
                      options={companyList}
                      readOnly={props.isReadOnly}
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <div className={'form-sub-title'}>TASK DESCRIPTION</div>
            <table className={'form-table'}>
              <tbody>
                <tr>
                  <th>Work Description</th>
                  <td>
                    <CustomTextarea
                      name={'description'}
                      className={'form'}
                      onChange={props.handleChange}
                      value={props.data?.description}
                      disabled={props.isReadOnly}
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ width: '300px' }}>Work Risk</th>
                  <td>
                    <div className={'flex-row flex-row-center gap-2'}>
                      {props.data?.workRisk === 'GENERAL' && (
                        <CustomButton
                          text={'General Work'}
                          className={'grid-button blue cursor-none'}
                        />
                      )}
                      {props.data?.workRisk === 'HIGH' && (
                        <CustomButton
                          text={'High-Risk Work'}
                          className={'form-button red cursor-none'}
                        />
                      )}
                    </div>
                  </td>
                </tr>
                <tr>
                  <th className={'form-required'}>Location / Unit No.</th>
                  <td>
                    <div className={'group-td-column'}>
                      <CustomText
                        name={'locationText'}
                        className={'form'}
                        value={props.data?.locationText}
                        isBtnSearch={!props.isReadOnly}
                        onSearchAction={() => {
                          setIsWorkLocationModalOpen(true);
                        }}
                        readOnly={true}
                      />
                      <PermitIssueMap location={props.data?.location} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>Register</th>
                  <td>
                    <CustomText
                      name={'receiverNm'}
                      className={'form'}
                      readOnly={true}
                      value={props.data?.receiverNm}
                      defaultValue={props.userInfo.fullName}
                      onChange={props.handleChange}
                    />
                  </td>
                </tr>
                <tr>
                  <th>Operator</th>
                  <td>
                    <CustomText
                      onChange={props.handleChange}
                      name={'operator'}
                      className={'form'}
                      value={(props.data?.operator ?? []).join(',')}
                      readOnly={true}
                      isBtnSearch={!props.isReadOnly}
                      onSearchAction={() => {
                        setIsUserSearchModalOpen(true);
                      }}
                    />
                    <div className="work-select-multi">
                      {props.data?.operator?.map((item: string, index: number) => (
                        <div className="selected-item" key={index}>
                          <span>{item}</span>

                          {!props.isReadOnly && (
                            <a onClick={() => deleteOperatorItem(item)}>
                              <img
                                src={FormTabXBlack}
                                alt="close"
                                style={{ width: '15px', height: '15px' }}
                              />
                            </a>
                          )}
                        </div>
                      ))}
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>Validity Period</th>
                  <td>
                    <div className={'group-td-row'}>
                      <CustomDatetime
                        name={'validStartTime'}
                        className={'form'}
                        onChange={props.handleChange}
                        value={props.data?.validStartTime}
                        disabled={props.isReadOnly}
                        defaultValue={dateUtil.getTodayMorning7()}
                      />
                      <span>-</span>
                      <CustomDatetime
                        name={'validEndTime'}
                        className={'form'}
                        onChange={props.handleChange}
                        value={props.data?.validEndTime}
                        disabled={props.isReadOnly}
                        defaultValue={dateUtil.getAfterMonth19()}
                      />
                    </div>
                  </td>
                </tr>

                <tr>
                  <th>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        paddingRight: '10px',
                        alignItems: 'center'
                      }}
                    >
                      <span>Manpower Planning</span>
                      <div>
                        {!props.isReadOnly && (
                          <div
                            className={'action-button'}
                            onClick={() => {
                              addManPower();
                            }}
                          >
                            <span style={{ fontSize: '20px' }}>+</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </th>
                  <td>
                    <div className={'group-td-column'}>
                      <div className={'custom-add'}>
                        <div className={'add-header'}>
                          <span className={'add-total'} style={{ width: '150px' }}>
                            Total
                          </span>
                          <span className={'add-cnt'} style={{ width: '100px' }}>
                            {props.data?.manPower?.reduce(
                              (acc: any, curr: any) =>
                                acc + (curr.manPower2 === '' ? 0 : +curr.manPower2),
                              0
                            ) ?? 0}
                          </span>
                        </div>
                        <div className={'add-list'}>
                          {props.data?.manPower?.map((item: any, index: number) => (
                            <div className={'add-item'} key={index}>
                              <div style={{ width: '150px' }}>
                                <CustomSelectSingle
                                  name={'manPower1'}
                                  className={'form'}
                                  onChange={(e) => handleChangeManPower(index, 'manPower1', e)}
                                  value={props.data?.manPower[index]?.manPower1}
                                  options={manpowerOptions}
                                  readOnly={props.isReadOnly}
                                />
                              </div>
                              <div style={{ width: '100px' }}>
                                <CustomNumber
                                  name={'manPower2'}
                                  className={'form'}
                                  onChange={(e) => handleChangeManPower(index, 'manPower2', e)}
                                  value={props.data?.manPower[index]?.manPower2}
                                  readOnly={props.isReadOnly}
                                />
                              </div>
                              {!props.isReadOnly && (
                                <div
                                  className={'action-button'}
                                  onClick={() => {
                                    delManPower(index);
                                  }}
                                >
                                  <span style={{ fontSize: '20px' }}>-</span>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default Form05LiftingDetail;
